export { default as handleSearchPage } from './handleSearchPage';
export { default as handleSearchControl } from './handleSearchControl';



// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/index.ts